import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as stocksActions from '../actions/stocks.actions';
import {
  ExpectedStocks,
  initialStocksState,
  InitStocksState,
  ReckonExpectedStocks,
} from '../state/stocks.state';

export const stocksFeatureStoreKey: string = 'stocksState';

export const reducers = (
  state: InitStocksState,
  action: Action,
): InitStocksState => {
  return initStocksReducer(state, action);
};

export const initStocksReducer = createReducer(
  initialStocksState,
  on(stocksActions.updateStocksAveragePrice, (state, { expectedStocks }) => ({
    ...state,
    expectedStocks,
    reckonExpectedStocks: getCalculatedStocksAveragePrice(
      state,
      expectedStocks,
    ),
    showStocksAveragePrice: true,
  })),
  on(stocksActions.resetStocksAveragePrice, (state) => ({
    ...state,
    expectedStocks: null,
    showStocksAveragePrice: false,
    reckonExpectedStocks: null,
  })),
);

export const stocksFeature = createFeature({
  name: stocksFeatureStoreKey,
  reducer: reducers,
});

export const getCalculatedStocksAveragePrice = (
  state: InitStocksState,
  expectedStocks: ExpectedStocks,
): ReckonExpectedStocks[] => {
  const reckonStocks: ReckonExpectedStocks[] =
    calculateReckonStocks(expectedStocks);
  const stateReckonStocks: ReckonExpectedStocks[] =
    state.reckonExpectedStocks ?? [];
  return [...stateReckonStocks, ...reckonStocks];
};

const calculateReckonStocks = (
  expectedStocks: ExpectedStocks,
): ReckonExpectedStocks[] => {
  const totalStockPurchased: number =
    expectedStocks.investingAmount / expectedStocks.stockPrice;
  const totalInvestedPrice: number =
    expectedStocks.averagePrice * expectedStocks.purchasedStocks;
  const totalStockInvested: number =
    totalStockPurchased + expectedStocks.purchasedStocks;
  const totalAveragePrice: number =
    (expectedStocks.investingAmount + totalInvestedPrice) / totalStockInvested;
  const totalInvestingAmount: number =
    expectedStocks.stockPrice * totalStockInvested;

  const reckonStocks: ReckonExpectedStocks = {
    stockName: expectedStocks.stockName,
    totalStockPurchased: parseFloat(totalStockPurchased.toFixed(2)),
    totalAveragePrice: parseFloat(totalAveragePrice.toFixed(2)),
    totalInvestedPrice: parseFloat(totalInvestedPrice.toFixed(2)),
    totalStockInvested: parseFloat(totalStockInvested.toFixed(2)),
    totalInvestingAmount: parseFloat(totalInvestingAmount.toFixed(2)),
  };
  return [reckonStocks];
};
